module.exports = __webpack_public_path__ + "img/Graphic.b91dffbf.png";